module.exports = __webpack_public_path__ + "static/features3-19ec5e657512d37c83e54ed66ab79bb4.png";